import { LocalStorageKeys } from './../models/local-storage-keys.model';
import { LocalCacheModel } from './../models/local-cache.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalCacheService {
  get(name: any): LocalCacheModel {
    const item = localStorage.getItem(name);

    if (item) {
      const parsed = JSON.parse(item);

      if (
        parsed &&
        parsed.name &&
        parsed.value &&
        new Date() < new Date(parsed.expired)
      ) {
        return parsed;
      }
    }

    return undefined;
  }

  set(model: LocalCacheModel) {
    if (model) {
      const date = new Date(Date.now() + 3600 * 1000 * 24);
      model.expired = new Date(date);
      localStorage.setItem(model.name, JSON.stringify(model));
    }
  }

  remove(name: string) {
    localStorage.removeItem(name);
  }

  removeAllKeys() {
    const keys = [
      LocalStorageKeys.AllMunicipalitiesKey,
      LocalStorageKeys.BuildingCategoryKey,
      LocalStorageKeys.DashboardKey,
      LocalStorageKeys.MunicipalitiesKey,
      LocalStorageKeys.PeriodsKey,
      LocalStorageKeys.BuildingsMarkersKey,
      LocalStorageKeys.AccountKey,
    ];

    keys.forEach((x) => {
      localStorage.removeItem(x);
    });
  }
}
